var map = {
	"./arrow_next.svg": "883b",
	"./arrow_prev.svg": "9dc0",
	"./bg1.jpg": "9f48",
	"./bg2.jpg": "3214",
	"./intro_bg2.jpg": "67eb",
	"./logo.png": "da65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2826";